import { css, jsx } from '@emotion/react';
import { Link } from '@zapier/design-system';
import { useUniversalNavContext } from '../../../universal-nav/hooks';
import { baseReset, boxSizing, listReset, } from '../../../utils/style-mixins/reset';
const Styles = {
    root: css `
    ${boxSizing};
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  `,
    cell: css `
    ${boxSizing};
    flex-grow: 1;
    flex-shrink: 0;
    text-align: center;
  `,
    title: css `
    ${baseReset};
    font: 'var(--zds-small-print-3)';
    color: var(--zds-gray-warm-9, #413735);
    white-space: nowrap;
  `,
    icons: css `
    ${listReset};
    display: flex;
    width: min-content;
    margin: 0 auto;
  `,
    iconItem: css `
    ${boxSizing};
    margin-right: 10px;
    &:last-of-type {
      margin-right: 0;
    }
  `,
    icon: (icon) => css `
    ${boxSizing};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    background-color: var(--zds-gray-warm-5, #b5b2aa);

    &:hover,
    &:focus {
      background-color: ${icon.color};
      outline: none;
    }
  `,
    iconSvg: css `
    ${boxSizing};
    width: 16px;
    height: 16px;
    fill: var(--zds-gray-warm-1, #f9f7f3);

    > svg {
      width: inherit;
      height: inherit;
    }
  `,
};
const SocialIcon = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    return (jsx(Link, { "aria-label": props.title, title: props.title, color: null, css: Styles.icon(props), "data-testid": props.title, href: getFullyQualifiedURL(props.href) },
        jsx("span", { css: Styles.iconSvg, dangerouslySetInnerHTML: { __html: props.svg }, "data-zds": true })));
};
export const SocialIcons = ({ icons, title = 'Follow us' }) => {
    const iconNodes = icons.map((icon) => {
        return (jsx("li", { key: icon.title, css: Styles.iconItem, "data-zds": true },
            jsx(SocialIcon, Object.assign({}, icon))));
    });
    return (jsx("div", { css: Styles.root, "data-zds": true },
        jsx("div", { css: Styles.cell, "data-zds": true },
            jsx("h3", { css: Styles.title, "data-zds": true }, title)),
        jsx("div", { css: Styles.cell, "data-zds": true },
            jsx("ul", { css: Styles.icons, "data-zds": true }, iconNodes))));
};
//# sourceMappingURL=SocialIcons.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
